import { render, staticRenderFns } from "./wechatForm.vue?vue&type=template&id=d2444c56&scoped=true"
import script from "./wechatForm.vue?vue&type=script&lang=js"
export * from "./wechatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2444c56",
  null
  
)

export default component.exports